/**
 * eRCMS.Api
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { Country } from './country';
import { ModelCase } from './modelCase';
import { RelationshipType } from './relationshipType';
import { SexType } from './sexType';

export interface FamilyMember { 
    id?: string;
    caseId?: string;
    _case?: ModelCase;
    givenName?: string;
    surname?: string;
    maidenName?: string;
    dateOfBirth?: string;
    placeOfBirth?: string;
    placeOfBirthRegionCity?: string;
    alias?: string;
    languageSpoken?: string;
    relationship?: RelationshipType;
    nationalityCountryCode?: string;
    physicalDescription?: string;
    sex?: SexType;
    isAnonymized?: boolean;
    nationalityCountry?: Country;
}